import { useEffect, useState } from "react"
import { useNavigate, Outlet } from "react-router-dom"
import { auth } from "../Firebase/config"
import { onAuthStateChanged } from "firebase/auth"
import { signOut } from "firebase/auth"
import Notify from "../Components/Componentslogic/Usenotifications"
import axios from "axios"

export const ProtectedAdminpage = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(null)
  const [loading, setLoading] = useState(true)
  const navigate = useNavigate()
  // Logout Function: Clears session cookie & Firebase auth
  const logoutUser = () => {
    document.cookie = "session=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;"
    signOut(auth)
    Notify("Access Denied Please Login again.", "error")
    navigate("/Login")
  }

  // Function to check authentication status from backend
  const checkAuth = async () => {
    try {
      const response = await axios.get(`/api/check-auth`, {
        headers: {
          "Content-Type": "application/json",
        },
        withCredentials: true,
      })
      const userRole = response.data.role

      if (userRole === "Manager") {
        setIsAuthenticated(true)
      } else {
        logoutUser() // If not an admin, log out
      }
    } catch (error) {
      console.error("Session Invalid or Expired:", error)
      logoutUser() // Auto logout on session expiration or failure
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    // 🔹 Check authentication once when the component mounts
    checkAuth()

    // 🔹 Firebase Auth Listener - Triggers if user manually logs out
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (!user) {
        logoutUser() // Logout if Firebase detects sign-out
      }
    })

    const interval = setInterval(() => {
      checkAuth()
    }, 60 * 60 * 1000) // 🔹 New: Every 60 minutes (1 hour)

    return () => {
      unsubscribe() // Cleanup Firebase listener
      clearInterval(interval) // Cleanup session check
    }
  }, [])

  if (loading) return <div>Loading...</div>

  return isAuthenticated ? <Outlet /> : null
}
